"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = (0, _react.createContext)(null);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-pdf/dist/OutlineContext.js
// module id = 2891
// module chunks = 0